export default {
  closed: 'Closed',
  complete: 'Complete',
  released: 'Released',
  unreleased: 'Unreleased',
};
